import { useMutation, useQuery } from "@tanstack/react-query";
import { privateAxios, publicAxios } from "../axios";

const getSocietyInfoFromSirenNumber = async (
	sirenOrSiret: string,
	isClient: boolean,
) => {
	if (sirenOrSiret.length !== 9 && sirenOrSiret.length !== 14) return null;
	const { data } = await privateAxios.get(
		`/siren/search/${isClient ? "clients/" : ""}${sirenOrSiret}`,
	);
	return data;
};

export const useGetSocietyInfoFromSirenNumber = (
	sirenOrSiret: string | null,
	isClient = false,
) => {
	return useQuery({
		queryKey: ["societyBySiren", sirenOrSiret],
		queryFn: async () =>
			sirenOrSiret && getSocietyInfoFromSirenNumber(sirenOrSiret, isClient),
		enabled: !!sirenOrSiret,
		retry: false,
	});
};

export const useMutateGetSocietyInfoFromSiren = () => {
	return useMutation({
		mutationFn: async (siren: string) => {
			const { data } = await publicAxios.get(`/siren/search/${siren}`);
			return data;
		},
	});
};
